export default "__VITE_ASSET__BkupVYiQ__"